import React, { Component } from 'react';

import {} from '../App.css';

class NotFound extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false
        };
        
        this.state = {
            loaded: true
        };
    
    }
    render() {
        if (this.state.loaded) {
            return (
                <div className="Header-container">
                    Nothing to see
                </div>
            )
        }
    }
}

export default NotFound;


// WEBPACK FOOTER //
// ./src/components/NotFound.js